import React, { useState, useEffect } from 'react';
import './Toast.css';

const Toast = ({ toast, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Trigger animation
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => onClose(toast.id), 300); // Wait for animation
  };

  const handleOkClick = () => {
    handleClose();
  };

  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      case 'error':
      default:
        return '❌';
    }
  };

  const isInteractive = toast.interactive || toast.type === 'error';

  return (
    <div className={`toast toast-${toast.type} ${isVisible ? 'toast-visible' : ''} ${isInteractive ? 'toast-interactive' : ''}`}>
      <div className="toast-header">
        <span className="toast-icon">{getIcon()}</span>
        <div className="toast-content">
          <span className="toast-message">{toast.message}</span>
          {toast.type === 'error' && (
            <div className="toast-error-subtitle">
              Please review the error and click OK to continue.
            </div>
          )}
        </div>
        {!isInteractive && (
          <button className="toast-close" onClick={handleClose}>
            ×
          </button>
        )}
      </div>
      
      {toast.details && (
        <div className="toast-details">
          <button 
            className="toast-details-toggle"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? 'Hide Details' : 'Show Details'}
          </button>
          {showDetails && (
            <div className="toast-details-content">
              <pre>{JSON.stringify(toast.details, null, 2)}</pre>
            </div>
          )}
        </div>
      )}

      {/* Interactive footer with OK button for errors */}
      {isInteractive && (
        <div className="toast-footer">
          <button className="toast-ok-button" onClick={handleOkClick}>
            OK
          </button>
        </div>
      )}
    </div>
  );
};

export default Toast;